export default {
  breadcrumb: {
    taskList: 'Task List',
  },
  map: {
    title: 'Live Trajectory',
    legendCurrent: 'Current Position',
    legendPath: 'Path',
  },
  video: {
    title: 'Live Video',
    live: 'Live',
    detectionVideo: 'Detection Video',
    detectStream: 'Robot Dog Detection Stream',
  },
  dogInfo: {
    title: 'Robot Dog Info',
    battery: 'Battery',
    batteryTemperature: 'Battery Temp',
    voltage: 'Voltage',
    position: 'Position',
    positionXY: 'X: {x}, Y: {y}',
    noValue: '--',
    noValuePercent: '--%',
    postureStanding: 'Standing',
    postureLying: 'Lying Down',
    postureUnknown: 'Unknown',
    selfCheck: 'Self-check',
    selfCheckReady: 'Ready',
  },
  control: {
    title: 'Remote Control',
    taskSection: 'Task Control',
    moveSection: 'Movement',
    end: 'End',
    stand: 'Stand',
    lie: 'Lie Down',
    pause: 'Pause',
    resume: 'Resume',
    posture: 'Posture',
    moveHint: 'Stand up before moving',
  },
  alarmList: {
    total: '{count} total',
  },
  trajectoryMap: {
    connectingTitle: 'Connecting to map…',
    connectingSubtitle: 'Waiting for ROS `/map` data push',
    defaultAlarmLabel: 'Alarm',
  },
  messages: {
    startSuccess: 'Started successfully',
    startFailed: 'Failed to start inspection task',
    stopSuccess: 'Stopped successfully',
    stopFailed: 'Failed to stop inspection task',
    missingSn: 'Device SN not available',
    postureSuccess: '{action} succeeded',
    postureFailed: 'Posture control failed',
    noActiveTask: 'No task in progress',
    pauseSuccess: 'Paused successfully',
    pauseFailed: 'Failed to pause task',
    resumeSuccess: 'Resumed successfully',
    resumeFailed: 'Failed to resume task',
  },
}
